import { InjectionToken } from '@angular/core';

export const TranslationManagerConfigToken = new InjectionToken<TranslationManagerConfig>('TranslationManagerConfigToken');

export interface TranslationManagerConfig {
  schema: any
}
